import TecIndex from './TecIndex';

export default TecIndex;
